// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"62d1dd1a","845":"79d160e4"}[chunkId] + ".chunk.js";
};